export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/sellCarBackIcon.0fbd855d.svg","height":14,"width":8,"blurWidth":0,"blurHeight":0};